import {msg} from '@lit/localize';

export const tenants = {
	arc: {
		logo: '/assets/tenants/arc/logo.svg',
		logoInverted: '/assets/tenants/arc/logo.svg',
		name: 'CDLX',
		productname: 'Werkverzeichnis',
		fullProductName: 'CDLX Werkverzeichnis',
		privacyUrl: 'https://cdlx.de',
		footerLinks: [
			{label: msg('Help and Support'), link: 'mailto:support@aakio.info'},
			{label: msg('Feedback'), link: 'mailto:feedback@aakio.info'},
			{label: msg('About AAKIO'), link: 'https://aakio.info'},
			{label: msg('Terms and Conditions'), link: 'https://aakio.info/agb'},
			{label: msg('Imprint'), link: 'https://aakio.info/impressum'},
		],
	},
	aaki: {
		logo: '/assets/tenants/aaki/logo.svg',
		logoInverted: '/assets/tenants/aaki/logoInverted.svg',
		name: 'AAKIO',
		productname: 'Werkverzeichnis',
		fullProductName: 'AAKIO Werkverzeichnis',
		privacyUrl: 'https://aakio.io/datenschutz',
		footerLinks: [
			{label: msg('Help and Support'), link: 'mailto:support@aakio.info'},
			{label: msg('Feedback'), link: 'mailto:feedback@aakio.info'},
			{label: msg('About AAKIO'), link: 'https://aakio.info'},
			{label: msg('Terms and Conditions'), link: 'https://aakio.info/agb'},
			{label: msg('Imprint'), link: 'https://aakio.info/impressum'},
		],
	},
	kfn: {
		logo: '/assets/tenants/kfn/logo.svg',
		logoInverted: '/assets/tenants/kfn/logoInverted.svg',
		name: 'Stiftung Kunstfonds',
		productname: 'Werkverzeichnung',
		fullProductName: 'Stiftung Kunstfonds Werkverzeichnung',
		privacyUrl: 'https://www.kunstfonds.de/datenschutzerklaerung',
		footerLinks: [
			{
				label: msg('Contact'),
				link: 'https://www.kunstfonds.de/kontakt',
			},
			{
				label: msg('Privacy Policy'),
				link: 'https://www.kunstfonds.de/datenschutzerklaerung',
			},
			{
				label: msg('Imprint'),
				link: 'https://www.kunstfonds.de/impressum',
			},
		],
	},
	ksa: {
		logo: '/assets/tenants/ksa/logo.svg',
		logoInverted: '/assets/tenants/ksa/logo.svg',
		name: 'Kunststiftung Sachsen-Anhalt',
		productname: 'Werkverzeichnis',
		fullProductName: 'Werkverzeichnis der Kunststiftung Sachsen-Anhalt',
		privacyUrl: 'https://www.kunststiftung-sachsen-anhalt.de/datenschutz/',
		footerLinks: [
			{
				label: msg('Privacy Policy'),
				link: 'https://www.kunststiftung-sachsen-anhalt.de/datenschutz/',
			},
			{label: msg('Imprint'), link: 'https://www.kunststiftung-sachsen-anhalt.de/impressum/'},
		],
	},
};

export function getTenantData(tenant, field) {
	return tenants[tenant][field];
}
